// @core/api/endpoints/audittrail/get_compliance_report.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ComplianceReportResponse,
} from '../../../types/audittrail';

const BASE_PATH = '/audittrail';

/**
 * Get compliance report
 * Retrieves a compliance report by ID, including its generation status and download URL.
 */
export async function GetComplianceReport(
  report_id: string,
  options?: RequestOptions
): Promise<ComplianceReportResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/audit/compliance-reports/:report_id`;
  requestPath = requestPath.replace(':report_id', encodeURIComponent(report_id));
  const requestOptions = options;
  return client.get<ComplianceReportResponse>(requestPath, { ...requestOptions });
}
